'use client'

import { LocationSVG } from '@/components/svg/location/location'
import { BreadCrumbsV3 } from '@/components/v3/atoms/breadcrumbs/breadcrumbs'
import { VisibleOn } from '@/components/v3/atoms/visible-on'
import { useQueryParams } from '@/hooks/use-query-params'
import { findSelectedLocation } from '@/utils/regions-and-locations'
import cx from 'classnames'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { useIntersectionObserver } from 'usehooks-ts'
import s from './supplier-list-sticky-bar.module.scss'

type RegionWithLocations = {
  id: number
  name: string
  locations: {
    id: number
    name: string
  }[]
}

type Props = {
  regions: RegionWithLocations[]
  children: React.ReactNode
}

export const SupplierListStickyBarClient = ({ children, regions }: Props) => {
  const { isIntersecting, ref } = useIntersectionObserver({
    threshold: 0.1,
    initialIsIntersecting: true,
  })

  const { getLinkWith, get } = useQueryParams()
  const selectedLocation = get('location')
  const selectedRegion = get('region')

  const openLocationSelectModalLink = getLinkWith({
    modal: 'location-select',
  })

  const selectedLocationName = findSelectedLocation({
    regions,
    location: selectedLocation,
    region: selectedRegion,
  })

  const pathname = usePathname()

  const crumbs = [
    {
      label: 'Home',
      href: '/',
    },
  ]

  if (pathname?.includes('wedding-venues')) {
    crumbs.push({
      label: 'Wedding Venues',
      href: '/wedding-venues',
    })
  } else if (pathname?.includes('wedding-suppliers')) {
    crumbs.push({
      label: 'Wedding Suppliers',
      href: '/wedding-suppliers',
    })
  }

  return (
    <>
      <div ref={ref} />
      <div
        className={cx(s.container, {
          [s.hidden]: isIntersecting,
        })}
      >
        <VisibleOn desktop>
          <BreadCrumbsV3 crumbs={crumbs} />
        </VisibleOn>
        <div className={s.filtersContainer}>
          <Link
            className={cx(s.locationSelectLink, {
              [s.locationSelected]: !!selectedLocation,
            })}
            href={openLocationSelectModalLink}
            scroll={false}
          >
            <LocationSVG /> {selectedLocationName?.name || 'Search by location'}
          </Link>
          {children}
        </div>
      </div>
    </>
  )
}
